import { ChamberMember, CodebookModel, FileWrapper } from 'app/shared/model/shared.model';

export interface CaseRevisionModel {
  idCaseRevision: number;
  revisionType: CodebookModel[];
  fileWrapper: FileWrapper;
  multipartFile: File;
  revisionName: string;
  additionalDescription: string;
  revisionMark: string;
  revisionDate: Date;
  authorizedAuditor: ChamberMember;
  authorizationNumberExists: boolean;
  auditorFirstName: string;
  auditorLastName: string;
  auditorTitle: string;
}

export interface CaseRevisionViewModel {
  idCaseRevision: number;
  revisionType: string;
  additionalDescription: string;
  authorizedAuditor: string;
  revisionMark: string;
  revisionDate: Date;
}

export interface CaseRevisionsDataModel {
  reportsAttached: boolean;
  explanation: CodebookModel[];
}

export const caseRevisionInitial = {
  idCaseRevision: null,
  revisionType: [],
  fileWrapper: null,
  multipartFile: null,
  revisionName: '',
  additionalDescription: '',
  revisionMark: '',
  revisionDate: '',
  authorizedAuditor: {
    authorizationNumber: [],
    oib: '',
  },
  authorizationNumberExists: true,
  auditorFirstName: '',
  auditorLastName: '',
  auditorTitle: '',
};

export const caseRevisionDataInitial = {
  reportsAttached: false,
  explanation: []
}
